/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { color } from "@eisinc/XDL/Utilities";
import xScreen from "@eisinc/XDL/Utilities/xScreen";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    setIsOpenItemsStep: (value: boolean) => void;
    isLoadingInvoices: boolean;
}

export interface BoxStyle {
    wrapper?: InjectableCss;
    button?: ButtonPresentationProps;
    message?: TypographyProps;
}

export const styles: BoxStyle = {
    wrapper: {
        css: css`
            background-color: ${color("common.ui3")};
            border: 1px solid ${color("common.ui4")};
            padding: 13px;
            margin-left: auto;
            width: 100%;

            ${xScreen("gt", 768)} {
                max-width: 307px;
            }
        `,
    },
    button: {
        css: css`
            width: 100%;
            margin-top: 5px;
        `,
    },
    message: {
        lineHeight: "24px",
    },
};

type Props = OwnProps;

const MakeAPaymentBox: React.FunctionComponent<Props> = ({ setIsOpenItemsStep, isLoadingInvoices }: Props) => {
    return (
        <StyledWrapper className="make-a-payment-wrapper" {...styles.wrapper}>
            <Typography variant="p" {...styles.message}>
                {siteMessage("Custom_Payment_Center_MakeAPayment_Copy")}
            </Typography>

            <Button
                {...styles.button}
                variant="primary"
                onClick={() => {
                    setIsOpenItemsStep(false);
                }}
                disabled={isLoadingInvoices}
            >
                {translate("MAKE A PAYMENT")}
            </Button>
        </StyledWrapper>
    );
};

export default MakeAPaymentBox;
